<template>
  <Cmodal
    v-model="model"
    cancel-label="Never mind"
    centered
    size="lg"
    title="Permission Request"
    :tag="false"
    label=""
    confirm-label="Change Server Name"
    :progressing="progressing"
    @show="showModal"
  >
    <template>
      {{TabNo}}
      <div class="mb-3">
        Permission is required for this action. Select the user to seek permission from via text/Email.
      </div>
      <div>
        <b-table-simple>
          <b-thead>
            <b-tr>
              <b-th>First Name</b-th>
              <b-th>Last Name</b-th>
              <b-th>Role</b-th>
              <b-th>Cell Phone Number</b-th>
            </b-tr>
          </b-thead>
          <b-tbody v-if="!loading">
            <b-tr
              class="cursor-pointer"
              v-for="(user, index) in users"
              :key="index"
              @click="selectUser(user)"
              :variant="user.selected ? 'success' : ''"
            >
              <b-td>{{ user.FirstName }}</b-td>
              <b-td>{{ user.LastName }}</b-td>
              <b-td></b-td>
              <b-td>{{ user.MaskPhone }}</b-td>
            </b-tr>
          </b-tbody>
          <b-tbody v-else>
            <b-tr>
              <b-td colspan="100%" class="text-center">loading...</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
      <!-- <div>
        <b-btn variant="danger" block @click="model = false">
          Close
        </b-btn>
      </div> -->
      <pin-verification
        :orderId="tabNo"
        :tab-no="tabNo"
        v-model="verifyModal"
        :ApprovalIkey="ApprovalIkey"
        :user="selectedUserId"
        :action-type="actionType"
        @successPin="submitSuccessPin"
      />
    </template>
    <template #actions>
      <b-row class="flex-grow-1">
        <b-col cols="6">
          <b-btn variant="warning" block class="text-nowrap" :disabled="progressing || !selectedUser" @click="sendVerifyCode">
            Send Permission Request
            <font-awesome-icon v-if="progressing" spin icon="circle-notch" class="text-black align-middle mx-1" />
          </b-btn>
        </b-col>

        <b-col cols="6">
          <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="model = false">
            Never mind
          </b-btn>
        </b-col>
      </b-row>
    </template>
  </Cmodal>
</template>

<script>
import Cmodal from './Cmodal'
import PinVerification from './PinVerification.vue'
export default {
  name: 'approvePermission',
  components: {
    Cmodal,
    PinVerification
  },
  props: {
    value: {required: true, type: Boolean, default: false},
    actionType: {required: true, type: String},
    orderId: {
      required: false
    },
    tabNo: {
      type: [Number, String],
      default: ''
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    selectedUser() {
      return !!this.users.find(item => item.selected)
    },
    selectedUserId() {
      return this.users.find(item => item.selected)
    }
  },
  data() {
    return {
      progressing: false,
      users: [],
      verifyModal: false,
      loading: false,
      ApprovalIkey: null
    }
  },
  methods: {
    showModal() {
      const filter = {
        // UserID: localStorage.getItem('userID'),
        RestaurantID: this.$store.state.selectedRestaurantId,
        Action: this.actionType
      }
      this.users = []
      this.loading = true
      this.$api.getRestaurant.GetRestaurantApprovalManager(filter).then(res => {
        this.loading = false
        if (res.success) {
          res.RestaurantApprovalManagers.forEach(item => {
            this.$set(item, 'selected', false)
          })
          this.users = res.RestaurantApprovalManagers
        } else {
          this.loading = false
          this.$showError(res.message)
        }
      })
    },
    selectUser(user) {
      this.users.forEach(item => {
        this.$set(item, 'selected', false)
      })
      user.selected = true
    },
    sendVerifyCode() {
      const model = {
        // UserID: localStorage.getItem('userID'),
        RestaurantID: this.$store.state.selectedRestaurantId,
        Action: this.actionType,
        OrderId: this.orderId,
        ApprovalUserID: this.selectedUserId.ClientID,
        OrderDetailID: 0
      }
      this.progressing = true
      return this.$api.getRestaurant
        .SendApprovalCode(model)
        .then(res => {
          this.progressing = false
          if (res.success) {
            this.ApprovalIkey = res.ApprovalIkey
            this.verifyModal = true
          } else {
            this.$showError(res.message)
          }
        })
        .catch(() => {
          this.progressing = false
        })
    },
    submitSuccessPin() {
      this.$emit('acceptPermission')
    }
  }
}
</script>

<style scoped></style>
